import { render } from "./OptionsList.vue?vue&type=template&id=f70e1e7a&scoped=true"
import script from "./OptionsList.vue?vue&type=script&lang=js"
export * from "./OptionsList.vue?vue&type=script&lang=js"

import "./OptionsList.vue?vue&type=style&index=0&id=f70e1e7a&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70e1e7a"]])

export default __exports__